export default __webpack_public_path__ + "static/media/Bootstrap.054efa3f.png";